import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { TaskToDisplay } from '../../models/company-tasks/task-to-display';
import { CompanyTasksService } from '../../services/company-tasks/company-tasks.service';
import { CFDocumentStoreService } from '../../services/documents/cf-document-store.service';

@UntilDestroy()
@Component({
    selector: 'clfl-company-tasks',
    templateUrl: './company-tasks.component.html',
    styleUrls: ['./company-tasks.component.scss']
})
export class CompanyTasksComponent implements OnInit {
    public companyTasks: Array<TaskToDisplay> = [];
    @Output() public readonly onRegisterEvent = new EventEmitter<TaskToDisplay>();
    @Input()
    public isDocumentCanceled!: boolean;

    constructor(
        private companyTasksService: CompanyTasksService,
        private documentStoreService: CFDocumentStoreService
    ) {}

    ngOnInit(): void {
        this.companyTasksService
            .getCompanyTasks(this.documentStoreService.companyId, this.documentStoreService.selectedDocumentType)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (tasks) => (this.companyTasks = tasks)
            });
    }

    initiateAction(task: TaskToDisplay) {
        this.onRegisterEvent.emit(task);
    }
}
